export default {
	section_banner: {
		main_title: {
			one: '通貨',
			two: '交換',
		},
		sub_title: {
			one: 'Aのように',
			two: '銀行',
		},
		paragraph: {
			one: '売買 — お金のやり取りで、まだ何度も往復していませんか？JPWorldPayを使えば、その手間を省き、手続きを簡素化できます。',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},

	exchng_wallet: {
		title: 'ワンテザーウォレット',
		sub_title: {
			one: '交換と送金',
			two: 'すぐに',
		},
		paragraph: {
			one: '暗号資産の購入や送金でお困りですか？JPWorldPayなら、銀行と同じようにご利用いただけます。送金・出金が瞬時に行えるため、暗号資産取引は従来の銀行取引と同じくらいシンプルで便利です。',
		},
	},

	question_sec: {
		title: 'ボタンを1回クリックするだけで',
		sub_title: {
			one: 'お金を交換する',
			two: '簡単に',
		},
		paragraph:
			'自動為替レート、自動売買、使いやすいインターフェース。JPWorldPayは、取引をシンプルかつ効率的にします。リアルタイムのレート更新と直感的なデザインにより、ユーザーは混乱することなく、迅速に資産を売買できます。時間を節約し、利便性を高めるシームレスな体験をお楽しみください。',
		cta_buttons: {
			one: '始めましょう',
		},
	},

	online_mid: {
		label: '暗号資産とJPWorldPayポイント',
		title: {
			one: 'どれでも',
			two: '資産',
			three: 'いつでもお望み通りに',
		},
		paragraph:
			'暗号資産とJPWorldPayポイントの交換はシンプルで柔軟です。ある暗号資産を別の暗号資産に交換する場合でも、デジタル資産をJPWorldPayポイントに交換する場合でも、プロセスはスムーズかつ効率的です。シームレスな変換により、より自由でコントロールしやすい財務管理を実現できます。',
		cta_buttons: {
			one: '始めましょう',
		},
	},

	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
